import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { ApiService } from '@shared/services/api.service'
import { UserGroup, InputUserGroup } from '@shared/models/user-group.model'
import { PagesData } from '@shared/models/pages-data.model'

@Injectable({
  providedIn: 'root',
})
export class UserGroupsService {
  constructor(private apiService: ApiService) {}

  getUserGroups(
    pageIndex = 0,
    pageSize = 10,
    sort?: string,
    filterValues?: { [param: string]: any },
    fields?: (keyof UserGroup)[],
  ): Observable<PagesData<UserGroup>> {
    // TODO: switch when Go supports paginated list
    return this.apiService.getPageable<UserGroup>('/user-groups', pageIndex, pageSize, sort, filterValues, fields) as Observable<
      PagesData<UserGroup>
    >
  }

  getUserGroupList(fields?: (keyof UserGroup)[], filterValues?: { [param: string]: any }): Observable<UserGroup[]> {
    return this.getUserGroups(0, 1000, null, filterValues, fields).pipe(map((response) => response['data']))
  }

  getUserGroup(id: number): Observable<UserGroup> {
    return this.apiService.get(`/user-groups/${id}`).pipe(map((response) => response['data'] as UserGroup))
  }

  addUserGroup(userGroup: InputUserGroup): Observable<UserGroup> {
    return this.apiService.post(`/user-groups`, userGroup).pipe(map((response) => response['data'] as UserGroup))
  }

  editUserGroup(id: number, userGroup: InputUserGroup): Observable<UserGroup> {
    return this.apiService.patch(`/user-groups/${id}`, userGroup).pipe(map((response) => response['data'] as UserGroup))
  }

  deleteUserGroup(id: number) {
    return this.apiService.delete(`/user-groups/${id}`)
  }

  archiveUserGroup(id: number) {
    return this.apiService.patch(`/user-groups/${id}/archive`, {})
  }

  restoreUserGroup(id: number): Observable<UserGroup> {
    return this.apiService.patch(`/user-groups/${id}/restore`, {}).pipe(map((response) => response['data'] as UserGroup))
  }
}
